import { Component, ChangeDetectionStrategy, HostListener, Inject, AfterViewInit, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { RouterState, Navigate } from '@ngxs/router-plugin';
import { map, skip } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common'
import { environment } from '../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

  private readonly routesNoToolbar = [
    '/unsubscribe'
  ]

  hasToolBar$ = new BehaviorSubject<boolean>(true);
  routeUrl$: Observable<string>;

  @Select(RouterState.state) router$;

  constructor(
    private store: Store,
    @Inject(DOCUMENT) private _document: Document
  ) {
    // set favicon
    this._document.getElementById('appFavicon').setAttribute('href', environment.clientFavicon);
  }

  ngOnInit(): void {
    this.routeUrl$ = this.router$.pipe(
      map(state => {
        const url = state ? state['url'] : null;
        if (url){
          const hasToolbar = this.routesNoToolbar.filter(u => String(url).indexOf(u) > -1).length === 0;
          this.hasToolBar$.next(hasToolbar);
        }
        return url;
      })
    );
  }

  @HostListener('window:message', ['$event']) onMessage(data: any) {
    console.log(data);
  }

  navigate(routeUrl: string) {
    this.store.dispatch(new Navigate([routeUrl]));
  }

}
